import { Mic, StopCircle } from '@mui/icons-material';
import {
  Autocomplete as MUIAutocomplete,
  Box,
  Button,
  Checkbox as MUICheckbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Radio as MUIRadio,
  Radio,
  RadioGroup as MUIRadioGroup,
  Stack,
  TextField as MUITextField,
  TextFieldProps,
  Tooltip,
  Typography
} from '@mui/material';
import { DatePicker as MUIDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { IconArrowNarrowDown, IconArrowNarrowUp, IconClipboardCopy, IconX } from '@tabler/icons';
import NoustalkLogo from 'assets/images/contact-me/NousTalkLogoSVG.svg';
import useOptions from 'hooks/useOptions';
import { Fragment, memo, useCallback, useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import ReactPhoneInput from 'react-phone-input-mui';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import { store } from 'store';
import { SET_ITEMS, SET_STEPS } from 'store/actions';
import { v4 as uuid } from 'uuid';
import AutocompleteField from 'views/components/inputs/Autocomplete';
import CheckboxGroup from 'views/components/inputs/CheckboxGroup';
import PhoneNumber from 'views/components/inputs/PhoneNumber';
import RadioButtonGroup from 'views/components/inputs/RadioButtonGroup';
import TextField from 'views/components/inputs/TextField';
import FormBuilderDatePicker from '../inputs/FormBuilderDatePicker';
type Props = {
  item: any;
  items: any;
  isFirstItem?: boolean;
  isLastItem?: boolean;
  selectedItem?: any;
  setSelectedItem?: Function;
  setItems?: Function;
  previewOnly?: boolean;
  preferredLanguage?: string;
  steps?: any;
  choices?: any;
  showInput?: any;
  inputsLabel?: string;
  inputsLabelFrench?: string;
  description?: any;
  isDashBoard?: boolean;
  currentStep?: any;
  formContext?: any;
  collectScores?: boolean;
  disableFormInputs?: boolean;
  setError?: Function;
  setValue?: any;
  currentAudioInputEleId?: string;
  setCurrentAudioInputEleId?: Function;
};

const NewFormItem = ({
  item,
  currentStep,
  items: originalItems,
  isDashBoard = false,
  item: {
    _id,
    id,
    label,
    labelFrench,
    type,
    items,
    multiple,
    vertical,
    fontSize,
    logoSize,
    alignLogo,
    textAlign,
    bold,
    italic,
    underline,
    mandatory
  },
  isFirstItem,
  isLastItem,
  selectedItem = () => {},
  setSelectedItem = () => {},
  setItems = () => {},
  previewOnly,
  preferredLanguage = 'english',
  steps,
  choices,
  showInput,
  inputsLabel,
  inputsLabelFrench,
  description,
  formContext,
  collectScores,
  setError,
  disableFormInputs = false,
  setValue,
  currentAudioInputEleId,
  setCurrentAudioInputEleId
}: Props) => {
  console.log(preferredLanguage, 'preferred language');
  const { transcript, listening, resetTranscript, browserSupportsSpeechRecognition } = useSpeechRecognition();
  const AudioInputButton = () => (
    <div style={{ display: 'flex', gap: 1 }}>
      {!listening ? (
        <Tooltip title={<FormattedMessage defaultMessage="Start Voice Input" />}>
          <IconButton size="small" sx={{ height: 30, width: 30 }} disabled={disableFormInputs}>
            <Mic
              onClick={(e) => {
                e.stopPropagation();
                setCurrentAudioInputEleId && setCurrentAudioInputEleId(id);
                SpeechRecognition.startListening();
              }}
              sx={{ border: '1px solid black', borderRadius: '50%' }}
            />
          </IconButton>
        </Tooltip>
      ) : currentAudioInputEleId === id ? (
        <Tooltip title={<FormattedMessage defaultMessage="Stop Voice Input" />}>
          <IconButton
            disabled={disableFormInputs}
            onClick={(e) => {
              e.stopPropagation();
              SpeechRecognition.stopListening();
              setCurrentAudioInputEleId && setCurrentAudioInputEleId('');
              setValue(id, transcript.toString());
              resetTranscript();
            }}
          >
            <StopCircle sx={{ background: 'white', color: 'red' }} />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title={<FormattedMessage defaultMessage="Start Voice Input" />}>
          <IconButton size="small" sx={{ height: 30, width: 30 }} disabled>
            <Mic
              onClick={(e) => {
                e.stopPropagation();
                setCurrentAudioInputEleId && setCurrentAudioInputEleId(id);
                SpeechRecognition.startListening();
              }}
              sx={{ border: '1px solid black', borderRadius: '50%' }}
            />
          </IconButton>
        </Tooltip>
      )}
      {/* <p>{transcript}</p> */}
    </div>
  );
  console.log(type, '>>>>>>>');
  const intl = useIntl();
  const { logoOption } = useOptions();
  useEffect(() => {
    if (formContext && formContext?.formState) {
      if (!Object.keys(formContext.formState.errors).length) {
        setError && setError('');
      } else {
        setError && setError('error');
      }
    }
  }, [formContext, setError]);
  const RenderText = useCallback(
    () => (
      <Typography
        sx={{
          fontSize: fontSize || 14,
          fontWeight: isDashBoard ? '800' : bold ? 'bold' : 'regular',
          fontStyle: italic ? 'italic' : 'normal',
          textDecorationLine: underline ? 'underline' : 'none',
          textAlign: textAlign,
          whiteSpace: 'pre-line'
        }}
      >
        {preferredLanguage === 'french' ? labelFrench : label}
      </Typography>
    ),
    [fontSize, bold, italic, underline, textAlign, preferredLanguage, labelFrench, label, isDashBoard]
  );
  const RenderTextField = () =>
    !previewOnly ? (
      <MUITextField
        fullWidth
        size="small"
        disabled
        sx={{ pointerEvents: 'none' }}
        type={type === 'Email Field' ? 'email' : 'text'}
        multiline={type === 'Text Area'}
        rows={type === 'Text Area' ? 5 : undefined}
      />
    ) : formContext?.control && collectScores ? (
      <Stack direction="row" gap={1} alignItems="center">
        <Controller
          name={id}
          control={formContext?.control}
          disabled={disableFormInputs}
          render={({ field }) => (
            <TextField
              {...field}
              name={id}
              label={preferredLanguage === 'french' ? labelFrench : label}
              fullWidth
              type={type === 'Email Field' ? 'email' : 'text'}
              multiline={type === 'Text Area'}
              rows={type === 'Text Area' ? 5 : undefined}
              required={mandatory}
              disabled={disableFormInputs}
            />
          )}
        />
        {browserSupportsSpeechRecognition && type !== 'Email Field' ? <AudioInputButton /> : null}
      </Stack>
    ) : (
      <TextField
        name={id}
        disabled={disableFormInputs}
        label={preferredLanguage === 'french' ? labelFrench : label}
        fullWidth
        type={type === 'Email Field' ? 'email' : 'text'}
        multiline={type === 'Text Area'}
        rows={type === 'Text Area' ? 5 : undefined}
        required={mandatory}
      />
    );

  const RenderDateField = useCallback(() => {
    // Render directly for non-preview mode
    if (!previewOnly) {
      return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <MUIDatePicker
            label={preferredLanguage === 'french' ? labelFrench : label}
            value={null}
            disabled={disableFormInputs}
            onChange={(value) => {
              // Handle date change
              console.log(value); // Replace with the actual logic
            }}
            renderInput={(params: TextFieldProps) => (
              <MUITextField {...params} placeholder="MM/dd/yyyy" fullWidth name={id} defaultValue="" disabled={disableFormInputs} />
            )}
          />
        </LocalizationProvider>
      );
    }
    // When in preview mode, check for formContext and control
    if (formContext?.control && collectScores) {
      return (
        <Controller
          defaultValue={null}
          name={id}
          disabled={disableFormInputs}
          control={formContext.control} // Ensure control is passed here
          render={({ field, fieldState }) => (
            <FormBuilderDatePicker
              {...field}
              // label={preferredLanguage === 'french' ? labelFrench : label}
              required={mandatory}
              // error={!!fieldState.error}
              helperText={fieldState?.error?.message} // Display error messages if available
              placeholder="MM/dd/yyyy"
              // disabled={disableFormInputs}
              formState={formContext.formState} // Pass formState if required by DatePicker
            />
          )}
        />
      );
    }
    // Fallback when formContext is missing in preview mode
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MUIDatePicker
          label={preferredLanguage === 'french' ? labelFrench : label}
          value={null}
          disabled={disableFormInputs}
          onChange={(value) => {
            // Handle date change
            console.log(value); // Replace with the actual logic
          }}
          renderInput={(params: TextFieldProps) => (
            <MUITextField {...params} placeholder="MM/dd/yyyy" fullWidth name={id} defaultValue="" disabled={disableFormInputs} />
          )}
        />
      </LocalizationProvider>
    );
  }, [
    formContext?.control,
    formContext?.formState,
    collectScores,
    disableFormInputs,
    mandatory,
    previewOnly,
    id,
    preferredLanguage,
    label,
    labelFrench
  ]);

  const RenderButtonField = useCallback(
    () =>
      !previewOnly ? (
        <Button fullWidth size="small" sx={{ pointerEvents: 'none' }} variant="contained">
          {preferredLanguage === 'french' ? labelFrench : label}
        </Button>
      ) : (
        <Button fullWidth size="small" variant="contained" disabled={disableFormInputs}>
          {preferredLanguage === 'french' ? labelFrench : label}
        </Button>
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [id, label, labelFrench, mandatory, preferredLanguage, previewOnly, type]
  );

  const RenderSingleAutoComplete = useCallback(
    () =>
      !previewOnly ? (
        <MUIAutocomplete
          options={items || []}
          isOptionEqualToValue={(option: any, value: any) => option.value === value.id}
          getOptionLabel={(option: any) => (preferredLanguage === 'french' ? option?.labelFrench : option.label)}
          freeSolo={false}
          renderInput={(params) => <MUITextField {...params} />}
          size="small"
        />
      ) : formContext?.control && collectScores ? (
        <Controller
          disabled={disableFormInputs}
          name={id}
          control={formContext?.control}
          render={({ field }) => (
            <AutocompleteField
              {...field}
              disabled={disableFormInputs}
              label={preferredLanguage === 'french' ? labelFrench : label}
              options={items || []}
              isOptionEqualToValue={(option: any, value: any) => option.value === value.id}
              getOptionLabel={(option: any) => (preferredLanguage === 'french' ? option?.labelFrench : option.label)}
              getOptionValue={(option: any) => option.id}
              freeSolo={false}
              required={mandatory}
            />
          )}
        />
      ) : (
        <AutocompleteField
          name={id}
          // disabled={disableFormInputs}
          label={preferredLanguage === 'french' ? labelFrench : label}
          options={items || []}
          isOptionEqualToValue={(option: any, value: any) => option.value === value.id}
          getOptionLabel={(option: any) => (preferredLanguage === 'french' ? option?.labelFrench : option.label)}
          getOptionValue={(option: any) => option.id}
          freeSolo={false}
          required={mandatory}
        />
      ),
    [id, items, label, labelFrench, mandatory, preferredLanguage, previewOnly, formContext?.control, collectScores, disableFormInputs]
  );

  const RenderMultiAutoComplete = useCallback(
    () =>
      !previewOnly ? (
        <MUIAutocomplete
          options={items || []}
          isOptionEqualToValue={(option: any, value: any) => option.value === value.id}
          getOptionLabel={(option: any) => (preferredLanguage === 'french' ? option?.labelFrench : option.label)}
          freeSolo={false}
          renderInput={(params) => <MUITextField {...params} />}
          multiple
          size="small"
        />
      ) : formContext?.control && collectScores ? (
        <Controller
          name={id}
          disabled={disableFormInputs}
          control={formContext?.control}
          render={({ field }) => (
            <AutocompleteField
              {...field}
              name={id}
              disabled={disableFormInputs}
              label={preferredLanguage === 'french' ? labelFrench : label}
              options={items || []}
              isOptionEqualToValue={(option: any, value: any) => option.value === value.id}
              getOptionLabel={(option: any) => (preferredLanguage === 'french' ? option?.labelFrench : option.label)}
              getOptionValue={(option: any) => option.id}
              freeSolo={false}
              multiple
              required={mandatory}
            />
          )}
        />
      ) : (
        <AutocompleteField
          name={id}
          label={preferredLanguage === 'french' ? labelFrench : label}
          options={items || []}
          isOptionEqualToValue={(option: any, value: any) => option.value === value.id}
          getOptionLabel={(option: any) => (preferredLanguage === 'french' ? option?.labelFrench : option.label)}
          getOptionValue={(option: any) => option.id}
          freeSolo={false}
          multiple
          required={mandatory}
          // disabled={disableFormInputs}
        />
      ),
    [id, items, label, labelFrench, mandatory, preferredLanguage, previewOnly, formContext?.control, collectScores, disableFormInputs]
  );
  const RenderPhoneInput = useCallback(
    () =>
      !previewOnly ? (
        <Box sx={{ pointerEvents: 'none', '& input': { height: '1em !important' } }}>
          <ReactPhoneInput value="" defaultCountry={'ca'} component={MUITextField} disabled />
        </Box>
      ) : formContext?.control && collectScores ? (
        <Controller
          disabled={disableFormInputs}
          name={id}
          render={({ field }) => (
            <PhoneNumber
              disabled={disableFormInputs}
              {...field}
              label={preferredLanguage === 'french' ? labelFrench : label}
              fullWidth
              required={mandatory}
            />
          )}
        />
      ) : (
        <PhoneNumber
          name={id}
          label={preferredLanguage === 'french' ? labelFrench : label}
          fullWidth
          required={mandatory}
          disabled={disableFormInputs}
        />
      ),
    [id, label, labelFrench, mandatory, preferredLanguage, previewOnly, formContext?.control, collectScores, disableFormInputs]
  );

  const RenderImage = useCallback(
    () => (
      <Box style={{ textAlign: alignLogo }}>
        <img src={logoOption?.value || NoustalkLogo} alt="image3" style={{ width: logoSize + '%' }} />
      </Box>
    ),
    [alignLogo, logoOption?.value, logoSize]
  );

  const RenderNumberField = useCallback(
    () =>
      !previewOnly ? (
        <MUITextField fullWidth size="small" disabled sx={{ pointerEvents: 'none' }} type="number" />
      ) : formContext?.control && collectScores ? (
        <Controller
          name={id}
          disabled={disableFormInputs}
          render={({ field }) => (
            <TextField
              {...field}
              disabled={disableFormInputs}
              label={preferredLanguage === 'french' ? labelFrench : label}
              fullWidth
              type="number"
              required={mandatory}
            />
          )}
        />
      ) : formContext?.control && collectScores ? (
        <Controller
          name={id}
          disabled={disableFormInputs}
          control={formContext?.control}
          render={({ field }) => (
            <TextField
              {...field}
              name={id}
              disabled={disableFormInputs}
              label={preferredLanguage === 'french' ? labelFrench : label}
              fullWidth
              type="number"
              required={mandatory}
            />
          )}
        />
      ) : (
        <TextField
          name={id}
          label={preferredLanguage === 'french' ? labelFrench : label}
          fullWidth
          type="number"
          required={mandatory}
          disabled={disableFormInputs}
        />
      ),
    [id, label, labelFrench, mandatory, preferredLanguage, previewOnly, formContext?.control, collectScores, disableFormInputs]
  );

  const ShowQuestionnaireField = useCallback(
    () => (
      <Box sx={{ pointerEvents: previewOnly ? 'auto' : 'none', '& input': { height: '1em !important' } }} key="box">
        <Typography sx={{ color: '#999', mb: 2 }}>
          {preferredLanguage === 'french' ? labelFrench || label : label || labelFrench} {mandatory ? '*' : ''}
        </Typography>
        <Grid container spacing={2}>
          {/* <Grid item xs={showInput ? 4 : 6}> */}
          <Grid item xs={6}>
            <Typography variant="h5">{preferredLanguage === 'french' ? description?.labelFrench : description?.label}</Typography>
          </Grid>
          {/* <Grid item xs={showInput ? 4 : 6}> */}
          <Grid item xs={6}>
            <Typography variant="h5">
              {choices?.map((item, i) => (
                <Fragment key={item.id}>
                  {preferredLanguage === 'french' ? item?.labelFrench : item?.label}
                  {choices?.length - 1 !== i ? '/' : ''}{' '}
                </Fragment>
              ))}
            </Typography>
          </Grid>
          {/* {showInput && (
            <Grid item xs={4}>
              <Typography variant="h5">
                {preferredLanguage === 'french' ? inputsLabelFrench || inputsLabel : inputsLabel || inputsLabelFrench}
              </Typography>
            </Grid>
          )} */}
        </Grid>
        <Divider sx={{ mt: 2 }} />

        {(items || []).map(({ id: itemId, label, labelFrench }, i) => (
          <Grid container key={itemId} sx={(theme) => ({ borderBottom: `1px solid ${theme.palette.divider}`, py: 1 })}>
            {/* <Grid item xs={showInput ? 4 : 6} sx={{ pt: 1 }}> */}
            <Grid item xs={6} sx={{ pt: 1 }}>
              <Typography>{preferredLanguage === 'french' ? labelFrench : label}</Typography>
            </Grid>
            {/* <Grid item xs={showInput ? 4 : 6}> */}
            <Grid item xs={6}>
              {!previewOnly ? (
                <MUIRadioGroup row name={itemId}>
                  {choices?.map((choice) => (
                    <FormControlLabel
                      value=""
                      control={<Radio />}
                      key={choice.id}
                      label={preferredLanguage === 'french' ? choice?.labelFrench : choice?.label}
                    />
                  ))}
                </MUIRadioGroup>
              ) : formContext?.control && collectScores ? (
                <Controller
                  disabled={disableFormInputs}
                  name={`${id}.${itemId}.value`}
                  control={formContext?.control}
                  render={({ field }) => (
                    <RadioButtonGroup
                      {...field}
                      disabled={disableFormInputs}
                      name={`${id}.${itemId}.value`}
                      label=""
                      options={choices || []}
                      row
                      difficulty="No"
                      preferredLanguage={preferredLanguage}
                    />
                  )}
                />
              ) : (
                <RadioButtonGroup
                  name={`${id}.${itemId}.value`}
                  label=""
                  options={choices || []}
                  row
                  difficulty="No"
                  disabled={disableFormInputs}
                  preferredLanguage={preferredLanguage}
                />
              )}
            </Grid>

            {/* {showInput && !previewOnly && (
              <Grid item xs={4} sx={{ pt: 1 }}>
                <MUITextField fullWidth size="small" disabled={!previewOnly} sx={{ pointerEvents: 'none' }} type="text" />
              </Grid>
            )}

            {showInput && previewOnly && (
              <Grid item xs={4} sx={{ pt: 1 }}>
                <TextField name={`${id}.${itemId}.text`} fullWidth />
              </Grid>
            )} */}
          </Grid>
        ))}
      </Box>
    ),
    [
      previewOnly,
      preferredLanguage,
      labelFrench,
      label,
      mandatory,
      // showInput,
      description?.labelFrench,
      description?.label,
      choices,
      // inputsLabelFrench,
      // inputsLabel,
      items,
      formContext?.control,
      collectScores,
      disableFormInputs,
      id
    ]
  );

  const RenderCheckboxGroup = useCallback(
    () =>
      !previewOnly ? (
        <FormControl>
          <FormGroup row={!vertical}>
            {(items || []).map((option: any) => {
              console.log(option, 'option');
              return (
                <FormControlLabel
                  control={<MUICheckbox color="primary" />}
                  label={preferredLanguage === 'french' ? option?.labelFrench : option.label}
                />
              );
            })}
          </FormGroup>
        </FormControl>
      ) : formContext?.control && collectScores ? (
        <Controller
          name={id}
          disabled={disableFormInputs}
          control={formContext?.control}
          render={({ field }) => (
            <CheckboxGroup
              {...field}
              name={id}
              disabled={disableFormInputs}
              label={preferredLanguage === 'french' ? labelFrench : label}
              options={items || []}
              row={!vertical}
              required={mandatory}
              needOnlyOneStarForMandatoryField
              labelKey={preferredLanguage === 'french' ? 'labelFrench' : 'label'}
            />
          )}
        />
      ) : (
        <CheckboxGroup
          name={id}
          label={preferredLanguage === 'french' ? labelFrench : label}
          options={items || []}
          row={!vertical}
          required={mandatory}
          needOnlyOneStarForMandatoryField
          disabled={disableFormInputs}
          labelKey={preferredLanguage === 'french' ? 'labelFrench' : 'label'}
        />
      ),
    [
      id,
      items,
      label,
      labelFrench,
      mandatory,
      preferredLanguage,
      previewOnly,
      vertical,
      formContext?.control,
      collectScores,
      disableFormInputs
    ]
  );

  const RenderRadioGroup = useCallback(
    () =>
      !previewOnly ? (
        <FormControl>
          <MUIRadioGroup name={id} row={!vertical}>
            {(items || []).map((option, i) => (
              <FormControlLabel
                key={option.value + i}
                value={option.value}
                control={<MUIRadio />}
                label={preferredLanguage === 'french' ? option?.labelFrench : option.label}
              />
            ))}
          </MUIRadioGroup>
        </FormControl>
      ) : formContext?.control && collectScores ? (
        <Controller
          name={id}
          disabled={disableFormInputs}
          control={formContext?.control}
          render={({ field }) => (
            <RadioButtonGroup
              {...field}
              disabled={disableFormInputs}
              key={'option.value'}
              name={id}
              label={preferredLanguage === 'french' ? labelFrench : label}
              options={items || []}
              row={!vertical}
              difficulty="No"
              preferredLanguage={preferredLanguage}
              required={mandatory}
            />
          )}
        />
      ) : (
        <RadioButtonGroup
          key={'option.value'}
          name={id}
          label={preferredLanguage === 'french' ? labelFrench : label}
          options={items || []}
          row={!vertical}
          difficulty="No"
          preferredLanguage={preferredLanguage}
          required={mandatory}
          disabled={disableFormInputs}
        />
      ),
    [
      id,
      items,
      label,
      labelFrench,
      mandatory,
      preferredLanguage,
      previewOnly,
      vertical,
      formContext?.control,
      collectScores,
      disableFormInputs
    ]
  );

  return (
    <Box
      sx={{
        border: !previewOnly ? '2px solid #eee' : 0,
        borderColor: selectedItem?.id === id ? '#009' : !isDashBoard ? '#f5f5f5' : 'gray',
        borderRadius: 3,
        px: 2,
        m: !previewOnly ? 1 : 0.5,
        minHeight: !previewOnly ? 100 : 0
      }}
      onClick={() => setSelectedItem({ ...item })}
    >
      {!previewOnly && (
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          {!!label && (
            <Typography sx={{ fontSize: 14, color: '#000' }}>
              {type !== 'Text' ? label : ''}
              {mandatory ? ' *' : ''}
            </Typography>
          )}
          <Stack direction="row" justifyContent="flex-end" alignItems="center">
            <Tooltip title={intl.formatMessage({ defaultMessage: 'Copy' })}>
              <IconButton
                sx={{ width: 30, height: 30 }}
                onClick={(e) => {
                  e.stopPropagation();

                  const updateNestedIds = (obj) => {
                    if (Array.isArray(obj)) {
                      return obj.map((item) => updateNestedIds(item));
                    } else if (typeof obj === 'object' && obj !== null) {
                      const newObj = { ...obj, id: uuid() }; // Update the id
                      delete newObj._id;
                      for (let key in newObj) {
                        if (typeof newObj[key] === 'object') {
                          newObj[key] = updateNestedIds(newObj[key]);
                        }
                      }
                      return newObj;
                    }
                    return obj;
                  };

                  setItems((pre) => {
                    const currentIndex = pre.map((obj) => obj.id).indexOf(id);
                    if (currentIndex === -1) return pre; // Ensure item is found

                    const itemToDuplicate = pre[currentIndex];
                    console.log(itemToDuplicate, 'item to duplicate');

                    // Create a new item by duplicating and updating all ids recursively
                    const newItem = updateNestedIds({ ...itemToDuplicate });
                    delete newItem._id;

                    // Insert the duplicate just after the original
                    const updatedItems = [...pre.slice(0, currentIndex + 1), newItem, ...pre.slice(currentIndex + 1)];

                    store.dispatch({ type: SET_ITEMS, payload: [...updatedItems] });
                    steps[currentStep ?? 0].items = updatedItems;
                    store.dispatch({ type: SET_STEPS, payload: steps });
                    return updatedItems;
                  });
                }}
              >
                <IconClipboardCopy />
              </IconButton>
            </Tooltip>

            <Tooltip title={intl.formatMessage({ defaultMessage: 'Move up' })}>
              <IconButton
                sx={{ width: 30, height: 30 }}
                disabled={isFirstItem}
                onClick={(e) => {
                  e.stopPropagation();

                  setItems((pre) => {
                    const currentIndex = pre.map((obj) => obj.id).indexOf(id);

                    if (currentIndex === 0) return pre;

                    const itemToMove = pre[currentIndex];
                    const temp = pre[currentIndex - 1];
                    pre[currentIndex - 1] = itemToMove;
                    pre[currentIndex] = temp;
                    store.dispatch({ type: SET_ITEMS, payload: [...pre] });
                    return [...pre];
                  });
                }}
              >
                <IconArrowNarrowUp />
              </IconButton>
            </Tooltip>

            <Tooltip title={intl.formatMessage({ defaultMessage: 'Move down' })}>
              <IconButton
                sx={{ width: 30, height: 30 }}
                disabled={isLastItem}
                onClick={(e) => {
                  e.stopPropagation();

                  setItems((pre) => {
                    const currentIndex = pre.map((obj) => obj.id).indexOf(id);

                    if (currentIndex === pre.length - 1 || currentIndex === -1) return pre;

                    const itemToMove = pre[currentIndex];
                    const temp = pre[currentIndex + 1];
                    pre[currentIndex + 1] = itemToMove;
                    pre[currentIndex] = temp;
                    store.dispatch({ type: SET_ITEMS, payload: [...pre] });
                    return [...pre];
                  });
                }}
              >
                <IconArrowNarrowDown />
              </IconButton>
            </Tooltip>

            <Tooltip title={intl.formatMessage({ defaultMessage: 'Remove' })}>
              <IconButton
                sx={{ width: 30, height: 30 }}
                onClick={(e) => {
                  e.stopPropagation();
                  const updatedItems = originalItems?.filter((item) => item.id !== id);
                  steps[currentStep ?? 0].items = updatedItems;
                  store.dispatch({ type: SET_ITEMS, payload: updatedItems });
                  store.dispatch({ type: SET_STEPS, payload: steps });
                  setItems((pre) => pre.filter((item) => item.id !== id));
                  setSelectedItem(null);
                }}
              >
                <IconX />
              </IconButton>
            </Tooltip>
          </Stack>
        </Stack>
      )}

      {(type === 'Text Field' || type === 'Email Field' || type === 'Text Area') && <RenderTextField />}

      {type === 'Autocomplete' && !multiple && <RenderSingleAutoComplete />}

      {type === 'Autocomplete' && multiple && <RenderMultiAutoComplete />}

      {type === 'Phone Number' && <RenderPhoneInput />}

      {type === 'Number Field' && <RenderNumberField />}

      {type === 'Checkbox Group' && <RenderCheckboxGroup />}

      {type === 'Radio Group' && <RenderRadioGroup />}

      {type === 'Text' && <RenderText />}
      {type === 'Logo' && <RenderImage />}

      {type === 'Questionnaire' && <ShowQuestionnaireField />}
      {type === 'Button' && <RenderButtonField />}
      {type === 'Date Field' && <RenderDateField />}

      {!isDashBoard && !previewOnly && (
        <Stack direction="row" justifyContent="flex-end">
          <Typography sx={{ fontSize: 11, mt: 1 }}>{type}</Typography>
        </Stack>
      )}
    </Box>
  );
};

export default memo(NewFormItem);
